import { render } from "./VolunteersContent.vue?vue&type=template&id=689cf216&scoped=true"
import script from "./VolunteersContent.vue?vue&type=script&lang=js"
export * from "./VolunteersContent.vue?vue&type=script&lang=js"

import "./VolunteersContent.vue?vue&type=style&index=0&id=689cf216&lang=scss&scoped=true"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689cf216"]])

export default __exports__